// extracted by mini-css-extract-plugin
export var width100 = "J_w d_w";
export var design3Pos = "J_vV d_0";